import Vue from "vue";
import JSONView from "vue-json-component";
import TreeView from "vue-json-tree-view";
Vue.use(TreeView);
Vue.use(JSONView);
